import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { useBloomreachPageRoutes, CmsHeadTags } from "@grandvisionhq/bloomreach";
import { MiniCartModal } from "@grandvisionhq/carts-v2";
import { Loader } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { WishlistContainer } from "@grandvisionhq/fun-wishlist/overview";
import { ErrorPage } from "@grandvisionhq/layout";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
const Page = () => {
  const { isWishlistEnabled, isMyAccountEnabled } = useFeatureToggles();
  const [shouldRedirect, setShouldRedirect] = React.useState(isMyAccountEnabled ? true : false);
  const { routes } = useBloomreachPageRoutes();
  const authState = useAccount();
  const isLoggedIn = authState === State.AuthState.LoggedIn;
  const isAuthLoading = authState === "UNKNOWN";
  const { onClick: navigateToWishlist } = useLink({ route: "me.wishlist" }, { replace: true }) || {};
  const { getLabel } = useIntl();
  React.useEffect(() => {
    if (isMyAccountEnabled) {
      if (!isAuthLoading && isLoggedIn) {
        navigateToWishlist?.();
      } else if (!isAuthLoading && !isLoggedIn) {
        setShouldRedirect(false);
      }
    }
  }, [isAuthLoading, isLoggedIn, isMyAccountEnabled, navigateToWishlist]);
  if (!isWishlistEnabled) {
    return /* @__PURE__ */ React.createElement(
      ErrorPage,
      {
        header: getLabel("common.pageNotFound.header"),
        subheader: getLabel("common.pageNotFound.subheader"),
        buttonText: getLabel("account.pageNotFound.buttonText")
      }
    );
  }
  if (isMyAccountEnabled && isAuthLoading || shouldRedirect) {
    return /* @__PURE__ */ React.createElement("div", { className: "wishlist-overview" }, /* @__PURE__ */ React.createElement(Loader, null));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, { title: getLabel("account.wishlist.page.title"), noIndex: true, noFollow: true }), /* @__PURE__ */ React.createElement(WishlistContainer, null), /* @__PURE__ */ React.createElement(MiniCartModal, { links: { cart: routes.cart, checkout: routes.checkout } }));
};
export {
  Page
};
//# sourceMappingURL=wishlist.js.map
